export default "__VITE_PUBLIC_ASSET__5bf21986__"